export default "__VITE_ASSET__CRkqrIls__"